import * as React from 'react';
import { TColors } from '@cian/ui-kit/colors';
import { UIHeading5 } from '@cian/ui-kit';
import * as styles from './SearchResultPosition.css';
import { IBetPosition } from '../../../../../../../../types/reducers/betPosition';
import { getLeadBetPositionText } from '../../v1/components/Services/ServiceContainer/utils';

export interface ISearchResultPositionProps {
  place: IBetPosition | null;
  color: TColors;
}

export const SearchResultPosition = ({ place, color }: ISearchResultPositionProps): React.ReactElement | null => {
  if (!place) {
    return null;
  }

  return (
    <div className={styles.root}>
      <UIHeading5 color={color}>{getLeadBetPositionText(place)}</UIHeading5>
    </div>
  );
};
